import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import {
  getEscalatedTickets,
  assignToBackOffice,
} from "../../../services/supportApi";
import { useToast } from "../../../mesageToast/ToastContainer";

const UnassignedPool = () => {
  const navigate = useNavigate();
  const addToast = useToast();
  const queryClient = useQueryClient();
  const [page] = useState(1);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["support-escalations", "unassigned", page],
    queryFn: () => getEscalatedTickets("escalated_backoffice", page, 20),
  });

  const assignMutation = useMutation({
    mutationFn: (ticketId) => assignToBackOffice(ticketId),
    onSuccess: (data, ticketId) => {
      if (addToast)
        addToast("Success", `Ticket #${ticketId} assigned to you`, "success");
      queryClient.invalidateQueries(["support-escalations"]);
      navigate("/BOD/support-escalations/my-tickets");
    },
    onError: () => {
      if (addToast) addToast("Error", "Failed to assign ticket", "error");
    },
  });

  const tickets = data?.data?.tickets || [];

  return (
    <div className="ticket-list">
      {isLoading && <p>Loading tickets...</p>}
      {isError && <p>Error loading tickets.</p>}

      {!isLoading && !isError && tickets.length === 0 && (
        <p>No unassigned tickets in the pool.</p>
      )}

      {!isLoading && !isError && tickets.length > 0 && (
        <table className="ticket-table">
          <thead>
            <tr>
              <th>Ticket ID</th>
              <th>Customer</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((ticket) => (
              <tr key={ticket._id || ticket.ticketId}>
                <td>{ticket.ticketId}</td>
                <td>{ticket.customerName || "N/A"}</td>
                <td>{ticket.priority || "Normal"}</td>
                <td>{ticket.status}</td>
                <td>
                  <button
                    onClick={() => assignMutation.mutate(ticket.ticketId)}
                    disabled={assignMutation.isPending}
                    className="assign-btn"
                  >
                    Assign to Me
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UnassignedPool;
